import {Injectable} from '@angular/core';
import {ApiService} from "./api.service";

@Injectable()
export class MessagesService {
  private MESSAGES_ENDPOINT = '/messages';
  private CONTACT_US_ENDPOINT = this.MESSAGES_ENDPOINT + '/contact-us';

  constructor (private apiService: ApiService) {
  }

  public contactUs(contactUsObject: Object): Promise<any> {
    return this.apiService.post(this.CONTACT_US_ENDPOINT, contactUsObject, 'application/json');
  }

}
